import { useParams, Navigate } from "react-router-dom";
import DetailTemplate from "../components/DetailTemplate";
import { medicalProcedureSchema } from "../seo/schemas";
import { PROCEDURE_CONTENT } from "../data/procedureContent";

export default function ProcedureDetail() {
  const { slug } = useParams();
  const data = PROCEDURE_CONTENT[slug];
  if (!data) return <Navigate to="/procedures" replace />;

  return (
    <DetailTemplate
      kind="Procedure"
      title={data.title}
      subtitle={data.subtitle}
      breadcrumb={[
        { label: "Procedures", to: "/procedures" },
        { label: data.shortTitle },
      ]}
      sections={data.sections}
      faq={data.faq}
      related={data.related}
      seo={{
        title: data.seoTitle,
        description: data.seoDescription,
        canonical: `/procedures/${slug}`,
        extraSchemas: data.schema ? [medicalProcedureSchema(data.schema)] : [],
      }}
    />
  );
}
